exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Open+Sans:300,300i,400,400i,600,700);", ""]);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Oswald:300,400,600,700);", ""]);

// module
exports.push([module.id, "body{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased}.no-select{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.offline-banner{position:absolute;display:flex;justify-content:center;background:#184e78;width:100%;z-index:23;height:20px;left:0;top:0;border-bottom-left-radius:8px;border-bottom-right-radius:8px;transition-property:all;transition-duration:.5s;transition-timing-function:cubic-bezier(0,1,.5,1);max-height:20px;font-family:Open Sans,sans-serif;color:#fff;font-size:12px;line-height:20px}.offline-banner__retry{cursor:pointer;margin-left:2px;text-decoration:underline}.offline-banner--closing{max-height:0}", ""]);

// exports
exports.locals = {
	"addGreen": "#4bb543",
	"inProgress": "#f5a623",
	"complete": "#5db348",
	"iconGrey": "#A4A4A4",
	"warmGreyTwo": "#9b9b9b",
	"gray": "#676767",
	"offBlack": "#2C2C2C",
	"lightElement": "#D8D8D8",
	"white": "#fff",
	"aoDarkBlue": "#184e78",
	"secondaryLabelFont": "#bababa",
	"nonExistant": "#9b9b9b",
	"red": "#D0011B"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/components/banners/MobileBadConnectionAlert/MobileBadConnectionAlert.scss
// module id = 1691
// module chunks = 0